// ui-button
export function buttonAppearanceValidator(value) {
    return ['primary', 'secondary', 'tertiary', 'danger', 'delete', 'warning'].includes(value);
}

export function buttonTypeValidator(value) {
    return ['fill', 'outline', 'blank'].includes(value);
}

export function buttonSizeValidator(value) {
    return ['normal', 'small', 'extra-small'].includes(value);
}

// ui-modal
export function modalSizeValidator(value) {
    return ['md', 'lg'].includes(value);
}
export function modalImagePropsValidator(value) {
    const validPositions = [
        'center',
        'top',
        'bottom',
    ];

    const hasValidSrc = value && typeof value.src === 'string';
    const hasValidObjectPosition = !value.objectPosition || validPositions.includes(value.objectPosition);

    return hasValidSrc && hasValidObjectPosition;
}

export const imagePositionValidator = (value) => {
  if (!value || typeof value !== 'string') return false;
  
  const keywords = ['center', 'top', 'bottom', 'left', 'right'];
  
  // Split by spaces and filter out empty strings
  const parts = value.trim().split(/\s+/).filter(part => part.length > 0);
  
  // Empty string is valid (browser default)
  if (parts.length === 0) return true;
  
  if (parts.length === 1) {
    // Single value: keyword, percentage, or length
    const part = parts[0];
    return keywords.includes(part) || 
           /^-?\d*\.?\d+(px|em|rem|%|vh|vw|ex|ch|cm|mm|in|pt|pc)$/.test(part) ||
           /^-?\d+(\.\d+)?%$/.test(part);
  }
  
  if (parts.length === 2) {
    // Two values: combinations of keywords, percentages, or lengths
    return parts.every(part => 
      keywords.includes(part) || 
      /^-?\d*\.?\d+(px|em|rem|%|vh|vw|ex|ch|cm|mm|in|pt|pc)$/.test(part) ||
      /^-?\d+(\.\d+)?%$/.test(part)
    );
  }
  
  // More than 2 values for background-position is invalid
  return false;
};